module.exports = __webpack_public_path__ + "media/bootstrap-icons/hdd-stack-83bd7f1a.svg";